import React from 'react';

const PopularIcon = ({ fill, width, height }) => {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1278.000000 1280.000000"
      preserveAspectRatio="xMidYMid meet"
      width={width}
      height={height}
    >
      <g
        transform="translate(0.000000,1280.000000) scale(0.100000,-0.100000)"
        fill={fill}
        filter="drop-shadow(2px 4px 6px rgba(0, 0, 0, 0.5))"
        stroke="none"
      >
        <path
          d="M6273 12604 l-251 -194 -264 157 c-144 86 -270 157 -279 157 -8 1
-111 -102 -228 -227 -154 -165 -218 -227 -229 -222 -171 65 -489 188 -528 204
l-52 20 -173 -265 c-99 -150 -180 -264 -189 -264 -8 0 -145 27 -304 60 -159
33 -295 60 -301 60 -6 0 -69 -130 -139 -290 l-129 -290 -191 8 c-105 4 -249 7
-320 7 l-130 0 -77 -299 c-43 -164 -81 -302 -86 -306 -4 -4 -145 -24 -313 -44
-168 -21 -308 -41 -311 -44 -3 -4 -18 -146 -33 -316 -14 -171 -28 -312 -31
-314 -2 -2 -137 -44 -301 -93 -163 -49 -299 -91 -302 -94 -4 -4 33 -521 43
-597 l5 -36 -285 -140 c-163 -81 -285 -147 -285 -154 0 -8 33 -146 74 -308 40
-162 72 -298 70 -302 -2 -3 -115 -86 -251 -183 -137 -98 -251 -181 -255 -184
-4 -4 47 -130 113 -281 65 -151 122 -284 125 -295 4 -16 -43 -67 -216 -240
-121 -121 -220 -224 -220 -229 0 -5 77 -127 170 -272 l171 -264 -186 -260
-186 -260 215 -235 215 -235 -33 -72 c-18 -40 -59 -125 -91 -188 -32 -63 -79
-161 -105 -216 l-47 -101 248 -194 c137 -107 248 -198 249 -203 0 -5 -38 -139
-85 -299 -47 -159 -85 -295 -85 -302 0 -6 123 -78 273 -160 149 -81 274 -150
276 -152 3 -2 -12 -145 -33 -319 -21 -173 -37 -316 -35 -318 2 -2 138 -49 301
-106 223 -77 298 -107 298 -119 3 -130 29 -614 34 -618 3 -4 144 -30 312 -59
169 -29 308 -54 309 -56 2 -2 32 -137 66 -300 34 -164 66 -303 70 -310 6 -10
82 -14 323 -17 l315 -3 105 -267 c58 -146 110 -278 115 -293 6 -16 15 -28 20
-28 5 0 145 22 312 49 166 28 306 48 311 45 4 -3 80 -126 168 -273 l161 -268
303 102 302 103 207 -243 207 -243 280 150 c154 82 284 147 290 143 5 -3 116
-96 246 -206 l237 -199 41 33 c34 28 123 96 452 349 7 5 110 -50 283 -153 149
-88 275 -159 279 -157 4 2 102 104 217 228 115 124 214 226 220 227 5 1 141
-49 300 -111 l290 -114 173 262 c95 143 179 262 187 264 9 2 151 -24 316 -58
165 -35 301 -61 303 -59 2 2 61 133 131 292 l128 288 201 -8 c110 -5 255 -8
320 -8 l119 0 76 297 c42 164 81 301 86 307 6 5 148 26 318 47 288 35 308 39
312 58 2 12 15 154 29 315 14 162 29 298 33 301 5 4 142 47 306 95 229 68 297
92 297 104 0 26 -39 521 -45 574 l-6 48 286 139 c157 76 285 144 285 150 0 6
-34 146 -75 312 -42 165 -74 302 -73 303 2 1 118 84 258 185 140 100 256 183
257 184 1 1 -52 126 -118 277 -66 150 -122 283 -125 294 -4 16 44 68 216 240
121 121 220 224 220 229 0 5 -77 127 -171 273 l-170 264 185 260 186 260 -202
222 c-112 122 -209 230 -216 239 -11 14 -8 27 24 90 20 40 83 168 139 285
l103 211 -249 194 c-136 106 -248 198 -249 205 0 7 38 142 85 300 47 158 85
293 85 299 0 7 -124 79 -275 160 -244 133 -274 152 -275 174 0 13 16 156 36
318 20 161 34 295 32 296 -1 2 -136 49 -298 105 -162 57 -296 104 -298 105 -1
2 -9 144 -17 316 -8 172 -18 316 -22 320 -4 4 -69 17 -143 29 -213 35 -474 82
-477 84 -2 3 -133 615 -133 624 0 1 -144 4 -321 5 l-320 3 -114 288 c-62 159
-116 291 -119 294 -3 3 -144 -17 -313 -45 -169 -28 -311 -48 -315 -46 -4 3
-80 126 -169 274 l-161 269 -302 -103 -302 -104 -208 244 -207 244 -62 -34
c-34 -19 -160 -86 -280 -151 -189 -101 -220 -115 -235 -103 -9 7 -116 96 -237
199 -121 102 -224 188 -230 191 -5 3 -123 -81 -262 -188z"
        />
      </g>
    </svg>
  );
};

export default PopularIcon;
